import { Option } from 'types/types';
import { useTranslation } from 'react-i18next';
import { StyledReactSelect } from 'styles/Styles.styled';
import { DropdownIndicator } from 'components/form/DropdownIndicator';

interface PaymentTermsProps {
  isDisabled: boolean;
  styles?: any;
}

const PaymentTerms: React.FC<PaymentTermsProps> = ({ isDisabled, styles }) => {
  const { t } = useTranslation();

  const daysOptions = [
    { value: '0', label: '0 days' },
    { value: '10', label: '10 days' },
    { value: '15', label: '15 days' },
    { value: '30', label: '30 days' },
    { value: '45', label: '45 days' },
    { value: '60', label: '60 days' },
    { value: '90', label: '90 days' },
  ] as Option[];

  return (
    <StyledReactSelect
      label={t('paymentTerms')}
      placeholder={t('placeholder.select')}
      name="termsOfPaymentOption"
      isDisabled={isDisabled}
      styles={styles}
      options={daysOptions.map((d) => {
        return { value: d.value, label: d.value } as Option;
      })}
      components={{ DropdownIndicator }}
    />
  );
};

export default PaymentTerms;
